import { FC } from "react";

import { StyledDashboardProgress } from "./Styled";

interface IDashboardProgress {
    value: number;
    limit: number;
}

export const DashboardProgress: FC<IDashboardProgress> = ({ value, limit }) => {
    return (
        <StyledDashboardProgress
            percent={value}
            percentPosition={{ align: "center", type: "inner" }}
            size={["100%", 12]}
            limit={limit}
            isOverMax={value >= limit}
            showInfo={value >= 5}
        />
    );
};
